import Commerce from '@chec/commerce.js'

export const commerce = new Commerce('pk_45377e920610a0cee632cd947dcccb2918bf93de9401a', true);